import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const getIsChatViewActive = (
    state: IApplicationState
): boolean => {
    const { route } = state.router;
    return (
        route === ERoutes.CHATS ||
        route === ERoutes.CHAT_GROUP ||
        route === ERoutes.CHAT ||
        route === ERoutes.CHAT_CARD ||
        route === ERoutes.CHAT_CARD_ACTIVITY ||
        route === ERoutes.CHAT_CARD_TIMING
    );
}
